export class CheckerRoutingPath {
  static readonly CHECKER_DOCUMENT = 'checker/:token';
  static readonly CHECKER = 'checker';
  static readonly CHECKER_DOCUMENT_BY_ID = 'checker-by-id';
}
